import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, Image, LinkData, TextInput } from '../../../types'
import { CmsConverterService, defaultLinkData, defaultTextInput } from '../../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class TopicTeaserBoxItemConverter extends CmsConverterService<TopicTeaserBoxItemData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const altText = formData.st_alt_text?.value
    const title = formData.st_title_text?.value
    const lazyLoad = formData.st_image_lazy_loading?.value
    return {
      image: CmsConverterService.mapImage(formData.st_image_reference, lazyLoad, altText, title),
      link: formData.st_link ?? defaultLinkData,
      overlay: formData.st_overlay?.value?.identifier ?? '',
      opacity: formData.st_overlay_opacity?.value?.identifier ?? '',
      text: formData.st_text ?? defaultTextInput,
      textSize: formData.st_text_size?.value?.identifier ?? ''
    }
  }
}

export const TOPIC_TEASER_BOX_ITEM_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, TopicTeaserBoxItemData>>('TopicTeaserBoxItemConverter')

export interface TopicTeaserBoxItemData extends ConvertedComponentData {
  image: Image;
  link: LinkData;
  overlay: string;
  opacity: number;
  text: TextInput;
  textSize: string;
  fsCatalogIndex?: number;
}
